import React from 'react';

interface EmojiItemProps {
  iconClass: string;
  iconColor?: string;
  iconShortName: string;
  onMouseDown: (e: React.MouseEvent) => void;
  onMouseUp: (e: React.MouseEvent) => void;
}

const EmojiItem: React.FC<EmojiItemProps> = ({
  iconClass,
  iconColor = '',
  iconShortName,
  onMouseDown,
  onMouseUp,
}) => {
  return (
    <a 
      className={`emoji_item ${iconColor}`} 
      onMouseUp={onMouseUp} 
      onMouseDown={onMouseDown}
      style={{ cursor: 'pointer' }}
    >
      <span className="emoji_outer emoji_sizer">
        <span className={`emoji_inner ${iconClass}`} data-short-name={iconShortName}></span>
      </span>
    </a>
  );
};

export default EmojiItem;
